// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: "AIzaSyCq2sqzL31gjgbxTPIUfffi38UJXKNI9J0",
  authDomain: "tennisstats-pro-aa65c.firebaseapp.com",
  projectId: "tennisstats-pro-aa65c",
  storageBucket: "tennisstats-pro-aa65c.firebasestorage.app",
  messagingSenderId: "216860630798",
  appId: "1:216860630798:web:f1b9152f76aec4f740415f",
  measurementId: "G-6LBQX04P8G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore()
